import { z } from 'zod';

/**
 * Execute action schema for proposals.
 * - APPROVE: Execute the proposal on-chain
 * - REJECT: Reject the proposal on-chain
 */
export const executeActionSchema = z.enum(['APPROVE', 'REJECT']);

/** Type for ExecuteAction values: 'APPROVE' | 'REJECT' */
export type ExecuteAction = z.infer<typeof executeActionSchema>;

/** Enum-like const for ExecuteAction values (e.g., ExecuteAction.APPROVE) */
export const ExecuteAction = executeActionSchema.enum;

/** Mirrors on-chain GroupModificationType ordering: Create=0, Update=1, Delete=2. */
export enum GroupModificationType {
  CREATE = 0,
  UPDATE = 1,
  DELETE = 2,
}
